var map = {
	"./0520151236.jpeg": 3363,
	"./wood1.JPG": 9945,
	"./wood10.0dff7e13.jpg": 5784,
	"./wood14.37809351.jpg": 1217,
	"./wood21.png": 2870,
	"./wood22.c90a0fdc.png": 1650,
	"./wood23.8fd327f5.png": 2915,
	"./wood7.e470dbc5.JPG": 8138,
	"./wood8.6b838e04.JPG": 4726,
	"./wood9.a5c33318.jpg": 7348
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6814;